var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKonsort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 14,
    viewBox: "0 0 102 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1327 0L14.1133 3.98303V9.62028L18.1327 13.6033H24.011L28.0305 9.62028V3.98303L24.011 0H18.1327ZM19.885 9.29765L18.559 7.98366V5.62552L19.885 4.31153H22.2647L23.5907 5.62552V7.98366L22.2647 9.29765H19.885Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5389 6.44676L33.1639 0H29.1562V13.6092H33.5072V7.16242L38.8823 13.6092H42.884V0H38.5389V6.44676Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8223 2.49893V6.20039L46.344 8.69931H52.5301L52.8261 8.99262V9.37977L52.5301 9.66721H43.8223V13.6092H54.6553L57.1771 11.1103V7.40879L54.6553 4.90986H48.4633L48.1732 4.61656V4.2294L48.4633 3.94197H57.1771V0H46.344L43.8223 2.49893Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1386 0L58.1191 3.98303V9.62028L62.1386 13.6033H68.0168L72.0363 9.62028V3.98303L68.0168 0H62.1386ZM63.8849 9.29765L62.5589 7.98366V5.62552L63.8849 4.31153H66.2646L67.5906 5.62552V7.98366L66.2646 9.29765H63.8849Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2137 6.49956V2.96234L83.2242 0H73.1963V13.6033H77.5473V9.34458H78.9088L82.4132 13.6033H87.7646L83.8458 8.84596L86.2137 6.49956ZM81.8272 4.51097V5.1973L81.253 5.7663H77.5473V3.94197H81.253L81.8272 4.51097Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0029 0V4.31153H91.8807V13.6092H96.2317V4.31153H101.11V0H87.0029Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5802 0H9.19326L5.16196 3.99476H4.35097V0H0V13.6092H4.35097V8.08338H7.88502L8.79665 8.99262V13.6092H13.1476V7.40292L10.1286 4.41712L14.5802 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonsort);
export default __webpack_public_path__ + "static/media/konsort.b6b43216104125b389302b33b179518d.svg";
export { ForwardRef as ReactComponent };